import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { ImageComponent } from './components/image/image.component';
import { McRAILoaderModule } from '../loader/loader.module';
import { ImageDetailDirective } from './directives/image-detail.directive';
import { McRAIButtonModule } from '../button/button.module';
import { VideoComponent } from './components/video/video.component';
import { MediaComponent } from './components/media/media.component';
import { McRAIIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    McRAILoaderModule,
    OverlayModule,
    McRAIButtonModule,
    McRAIIconModule
  ],
  declarations: [
    ImageComponent,
    ImageDetailDirective,
    VideoComponent,
    MediaComponent
  ],
  exports: [
    ImageComponent,
    ImageDetailDirective,
    VideoComponent
  ],
  entryComponents: [
    ImageComponent
  ]
})
export class McRAIMediaModule { }
